import React from 'react';

const LeftSliderFaucet = () => {
    return (
        <>
            <div id="my-carousel" class="carousel slide carousel-fade" data-ride="carousel" data-interval="5000">
                <div class="carousel-inner">
                    <div class="carousel-item active">
                        <a href="http://sh.st/st/4152f4bc9d1aca5236b3ab14a650a949/getzen.cash/auth/register?ref=334522" target="_blank" rel="noreferrer">
                            <img class="d-block w-100" src="./images/getzen-faucet.jpg" width="100%" alt="getzen.cash"/>
                        </a>
                    </div>
                    <div class="carousel-item">
                        <a href="http://sh.st/st/4152f4bc9d1aca5236b3ab14a650a949/globalhive.io/r/73592" target="_blank" rel="noreferrer">
                            <img class="d-block w-100" src="./images/globalhive.io.png" width="100%" alt="globalhive.io"/>
                        </a>
                    </div>
                    <div class="carousel-item">
                        <a href="http://sh.st/st/4152f4bc9d1aca5236b3ab14a650a949/GramFree.cc/?r=12461606" target="_blank" rel="noreferrer">
                            <img class="d-block w-100" src="./images/gramfree.website.png" width="100%" alt="gramfree.website"/>
                        </a>
                    </div>
                </div>
            </div>            
        </>
    )
};

export default LeftSliderFaucet;
